import editorEvent, { EditorEventName } from '../event/editorEvent';
import { EToastType, IToastOpts, TConfirmOpts } from '@/stores/feedback';

/**
 * 显示确认对话框并返回用户的选择结果
 *
 * **既可以通过回调函数获取用户选择结果，也可以通过 Promise 获取结果。**
 *
 * @param payload 确认对话框的配置选项
 * @returns Promise<boolean> 返回一个 Promise，解析为用户是否确认（true 表示确认，false 表示取消）
 */
const confirm = (payload: TConfirmOpts) => {
  return new Promise<boolean>((resolve) => {
    const handleConfirm = (confirmed: boolean) => {
      resolve(confirmed);
      payload.onConfirm?.(confirmed);
    };
    editorEvent.emit(EditorEventName.FEEDBACK_CONFIRM, {
      ...payload,
      onConfirm: handleConfirm
    });
  });
};

const showToast = (content: IToastOpts['content'], type: IToastOpts['type'] = EToastType.WARNING) => {
  editorEvent.emit(EditorEventName.FEEDBACK_TOAST, {
    content,
    type
  });
};

export { confirm, showToast };
